import { motion } from 'framer-motion';

export function TypingIndicator() {
  return (
    <div className="flex items-start gap-2 px-4 md:px-0">
      {/* Avatar */}
      <div className="w-8 h-8 rounded-full bg-brand-navy flex items-center justify-center flex-shrink-0">
        <span className="text-xs font-display text-brand-gold">P</span>
      </div>

      <div className="bg-brand-cream rounded-tr-bubble rounded-br-bubble rounded-bl-bubble rounded-tl-[4px] px-5 py-3">
        <div className="flex items-center gap-1.5">
          {[0, 1, 2].map((i) => (
            <motion.div
              key={i}
              className="w-2 h-2 rounded-full bg-brand-gold/60"
              animate={{
                scale: [1, 1.3, 1],
                opacity: [0.4, 1, 0.4],
              }}
              transition={{
                duration: 1.2,
                repeat: Infinity,
                delay: i * 0.15,
                ease: 'easeInOut',
              }}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
